import * as React from 'react';

import UnitTemplateActivityRow from './unitTemplateActivityRow';

import { DragHandle, FlagDropdown, NOT_APPLICABLE } from '../../../Shared/index';
import { editActivityPackLink } from '../../helpers/unitTemplates';

const GRIP_DOT_ROWS = [2, 8, 14];

const GripIcon = () => (
  <svg aria-hidden="true" fill="currentColor" height="16" viewBox="0 0 10 16" width="10">
    {GRIP_DOT_ROWS.map(y => (
      <React.Fragment key={y}>
        <circle cx="2" cy={y} r="1.5" />
        <circle cx="8" cy={y} r="1.5" />
      </React.Fragment>
    ))}
  </svg>
);

const UnitTemplateRow = ({
  className = '',
  'data-id': dataId = undefined,
  handleDelete,
  ref = undefined,
  style = undefined,
  unitTemplate,
  updateUnitTemplate
}) => {
  const [showActivities, setShowActivities] = React.useState<boolean>(false);

  function deleteUnitTemplate() {
    const confirm = window.confirm('Are you sure you want to delete ' + unitTemplate.name + '?');
    if (confirm) {
      handleDelete(unitTemplate.id);
    }
  }

  function handleHideActivitiesRow() {
    setShowActivities(!showActivities)
  }

  function handleSelectFlag(e) {
    const { target } = e;
    const { value } = target;
    const newUnitTemplate = {...unitTemplate}
    newUnitTemplate.flag = value
    updateUnitTemplate(newUnitTemplate)
  }

  function handleRemoveActivity(activityId: string) {
    const confirm = window.confirm('Are you sure you want to remove this activity?');
    if (confirm) {
      const newUnitTemplate = {...unitTemplate}
      const activityIds = unitTemplate.activities.map((activity) => activity.id)
      activityIds.splice(activityIds.indexOf(parseInt(activityId)), 1)
      newUnitTemplate.activity_ids = activityIds
      updateUnitTemplate(newUnitTemplate)
    }
  }

  function expandOrCollapseButton() {
    const imageLink = showActivities ? 'collapse.svg' : 'expand.svg';
    const imageAlt = showActivities ? 'Collapse' : 'Expand';
    const innerElement = <img alt={imageAlt} src={`https://assets.quill.org/images/shared/${imageLink}`} />
    return <button className="expand-collapse-button focus-on-light" onClick={handleHideActivitiesRow} type="button">{innerElement}</button>
  }

  function renderDiagnostics() {
    const { diagnostic_names } = unitTemplate;
    if((!diagnostic_names || !diagnostic_names.length)) { return NOT_APPLICABLE }
    return diagnostic_names.map(diagnostic => (
      <p key={diagnostic}>{diagnostic}</p>
    ));
  }

  const previewLink = `${window.postbuildEnv.DEFAULT_URL}/assign/featured-activity-packs/${unitTemplate.id}`;

  return (
    <tbody className={`unit-template ${className}`.trim()} data-id={dataId} id={unitTemplate.id} ref={ref} style={style}>
      <tr className="unit-template-row">
        <td className="controls-col">
          <DragHandle>
            <span className="drag-handle" title="Drag to reorder"><GripIcon /></span>
          </DragHandle>
          {expandOrCollapseButton()}
        </td>
        <td className="name-col">{unitTemplate.name}</td>
        <td className="flag-col" data-label="Flag"><FlagDropdown flag={unitTemplate.flag} handleFlagChange={handleSelectFlag} isLessons={false} /></td>
        <td className="diagnostics-col" data-label="Diagnostics">{renderDiagnostics()}</td>
        <td className="category-col" data-label="Pack Type">{unitTemplate.unit_template_category && unitTemplate.unit_template_category.name || NOT_APPLICABLE}</td>
        <td className="action-col">
          <a className="action-button focus-on-light" href={previewLink} rel="noopener noreferrer" target="_blank">preview</a>
        </td>
        <td className="action-col">
          <a className="action-button focus-on-light" href={editActivityPackLink(unitTemplate.id)} rel="noopener noreferrer" target="_blank">edit</a>
        </td>
        <td className="action-col">
          <button className="action-button interactive-wrapper focus-on-light" onClick={deleteUnitTemplate} type="button">delete</button>
        </td>
      </tr>

      {showActivities && (
        <tr className="unit-template-activities">
          <td>
            <UnitTemplateActivityRow activities={unitTemplate.activities} handleRemove={handleRemoveActivity} />
          </td>
        </tr>
      )}
    </tbody>
  )
}

export default UnitTemplateRow
